export const books = ['001.jpg'];